import { useState, useEffect } from "react";
import { ProposalList } from "./ProposalList.jsx";

export function LatestProposalsWidget({ configuration }) {
  const [proposals, setProposals] = useState([]);
  const [loadingProposals, setLoadingProposals] = useState(true);
  useEffect(() => {
    getProposalSet();
  }, []);

  const headers = {
    "Accept-Language": window.location.pathname.split("/")[1],
  };

  const getProposalSet = async () => {
    fetch(
      `/api/v1/proposals/${configuration.proposalsetId}/get_latest_proposals/?max_proposals=${configuration.max_proposals}`,
      { headers: headers }
    )
      .then((response) => response.json())
      .then((data) => {
        setLoadingProposals(false);
        setProposals(data.proposal_set);
      })
      .catch((error) => {
        setLoadingProposals(false);
        console.log(`proposal error: ${error}`);
      });
  };

  let out;
  if (!loadingProposals && proposals.length > 0) {
    out = (
      <div id="latest-proposals-widget-container" className="mt-3">
        <h4>{configuration.translations.lastProposals}</h4>
        <div id="latest-proposals-widget">
          <ProposalList
            proposals={proposals}
            configuration={configuration}
          />
        </div>
      </div>
    );
  } else {
    out = null;
  }

  return (
    <>
      {loadingProposals ? (
        <div className="vertical-center w-100 " style={{ minHeight: "400px" }}>
          <div className="spinner-border text-primary " role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        out
      )}
    </>
  );
}
